import { InjectionToken } from "@angular/core";
import { RequirementWorkflowPort } from "./requirement-workflow.port";

export const REQUIREMENT_WORKFLOW_PORT = new InjectionToken<RequirementWorkflowPort>("REQUIREMENT_WORKFLOW_PORT");
